import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import WorkTypeList from "./WorkTypeList";
import EditCategory from "./EditWorkType";
import { toast } from "react-toastify";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { useActiveDepartments } from "services/departmentService";
import { addWorkTypes } from "services/workTypeService";

const WorkType = (props) => {
  const [addnewform, setaddnewform] = useState(false);
  const [departmentID, setDepartmentID] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: departments, loading: departmentsLoading } =
    useActiveDepartments();
  const formattedDepartments = React.useMemo(() => {
    if (!departments) return [{ name: "ALL", departmentID: 0 }];
    return [{ name: "ALL", departmentID: 0 }, ...departments];
  }, [departments]);

  const closeform = () => {
    setaddnewform(false);
  };

  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const onChange = (e) => {
    setDepartmentID(e?.value?.departmentID || 0);
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    try {
      await addWorkTypes({
        ...e,
        departmentId: e.departmentId?.departmentID,
        appCode: e.appCode?.appCode,
        defaultProfitCost: e.defaultProfitCost?.nominalRef,
        rateCategoryId: e.rateCategoryId?.rateCategoryId,
        active: true,
      });
      toast.success("Work Type Added");
    } catch (error) {
    } finally {
      setIsSubmitting(false);
      setaddnewform(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex justify-content-between align-items-end mb-3 flex-shrink-0">
        <div className="form-group d-flex flex-column">
          <Label>Department</Label>
          <ComboBox
            data={formattedDepartments}
            className={`${styles["work-type-field-style"]} mt-1`}
            iconClassName="wa"
            required={true}
            textField={"name"}
            placeholder={"Search Department"}
            onChange={onChange}
            style={{ height: "40px" }}
            value={
              formattedDepartments.find(
                (d) => d.departmentID === departmentID
              ) || { name: "ALL", departmentID: 0 }
            }
            disabled={departmentsLoading}
          />
        </div>
        <Button
          className={`common-btn setting-btn`}
          onClick={() => {
            setaddnewform(true);
            props.open();
          }}
        >
          Add Work<br />
          Type
        </Button>
      </div>

      <div className="flex-grow-1 mb-2" style={{ minHeight: 0 }}>
        <WorkTypeList departmentID={departmentID} />
      </div>

      {addnewform && (
        <EditCategory
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default WorkType;
